import React from 'react';

import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { ScopeLegalEntityStatus } from '@app/models/users';

const STATUS_COLOR: Record<ScopeLegalEntityStatus, string> = {
  [ScopeLegalEntityStatus.InReview]: 'warning',
  [ScopeLegalEntityStatus.Confirmed]: 'success',
  [ScopeLegalEntityStatus.Rejected]: 'error',
};

interface IProps {
  status: ScopeLegalEntityStatus;
}

export const LegalEntityStatusTag: React.FC<IProps> = ({ status }) => {
  const spaceT = useTranslation(NSKeys.spaceSettings);

  return <Tag color={STATUS_COLOR[status]}>{spaceT.t(`legalEntityStatus.${status}` as const)}</Tag>;
};
